import { environment } from '../../../environments/environment'

export const mainDomain = environment.mainDomain
export const domainUrl = environment.domainUrl
export const cxDomain = environment.cxURL
export const cognitoProxy = environment.cognitoProxy
export const userProfileUrl = environment.userProfileUrl
export const forgotPassResetmailApi = environment.forgotPassResetmailApi
export const resetPassMailApi = environment.resetPassMailApi
export const poolId = environment.userPoolId
export const poolWebClientId = environment.userPoolWebClientId
export const identityPoolId = environment.identityPoolId
export const agentPoolId = environment.agentUserPoolId
export const agentPoolWebClientId = environment.agentUserPoolWebClientId
export const bucketName = environment.bucketName
export const ssoSecure = environment.secure
export const ssoSameSite = environment.sameSite
export const bxUrl = environment.bxURL
export const bxSearchUrl = environment.bxsearchSpeakingUrl
export const agentSearchUserProfileUrl = environment.agentSearchUserProfileUrl
export const agentCreateUserProfileUrl = environment.agentCreateUserProfileUrl
export const PAPER_BASED = 'Paper-based'
export const BOOKING_TYPE_MINOR = 'minor'
export const BOOKING_TYPE_KEY = 'bookingType'
export const regEXConst = {
    alphaNeumeric: /^[^a-zA-Z0-9]+$/,
    emailValidation: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
    numbersOnly: /^[0-9]+$/,
    validSpecialChar: /[-!@#$%^&*()_+|~=`{}\[\]:";\\'<>?,.\/]/g,
    lowerCase: /[a-z]/g,
    uppercase: /[A-Z]/g,
    digit: /\d/g,
    numericPhoneNum: /^[0-9 ()+-]*$/,
    uuid: /^[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}$/
}
